



































































import {Vue, Component, Prop} from "vue-property-decorator";
import Checkbox from "@/components/Table/Filters/Checkbox.vue";


@Component({
  components: {Checkbox}
})
export default class LoginForm extends Vue {
  public name: string = "LoginForm";

  @Prop({required: false, default: false})
  public reset!: boolean;

  protected showErrors = true;

  protected email: string = "";
  protected password: string = "";
  protected rememberMe: boolean = false;


  public onSubmit(): void {

    this.$emit("onSubmit", {
      email: this.email,
      password: this.password,
      redirectUrl: this.redirectUrl(),
      remember_me: this.rememberMe
    });

    this.showErrors = false;

    if (this.reset) {
      this.email = "";
      this.password = "";
    }
  }

  private onChangeAnyField(): void {

    this.$emit('on-change');

  }

  private redirectUrl(): any {
    return this.$route.query.redirectUrl;
  }

  mounted() {

  }
}
